import script from "./Config-Management.vue?vue&type=script&setup=true&lang=js"
export * from "./Config-Management.vue?vue&type=script&setup=true&lang=js"

import "./Config-Management.vue?vue&type=style&index=0&id=0a2550a8&scoped=true&lang=css"

import exportComponent from "/Users/Joe/Documents/Projects/MCR-WebFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2550a8"]])

export default __exports__